import { createSelector } from 'reselect';

/** @return {import("reducers/customersReducer").CustomerReducer} */
const getState = ({ customers }) => customers;

const getAll = createSelector(getState, customers => customers.data.byId);
const getAllCustomersData = createSelector(getState, customers => customers.data.all);
export const getCustomers = createSelector(getAllCustomersData, data => data.items || {});
export const getCustomersPage = createSelector(getAllCustomersData, data => data.page);

const getCustomersTable = createSelector(getState, ({ table }) => table);
const getCustomersTableSort = createSelector(getCustomersTable, ({ sort }) => sort);
const getCustomersTablePageSize = createSelector(getCustomersTable, ({ pageSize }) => pageSize);
const getCustomersTableSearchString = createSelector(getCustomersTable, ({ searchString }) => searchString);

export const getCustomersParams = createSelector(
  getCustomersPage,
  getCustomersTableSort,
  getCustomersTableSearchString,
  getCustomersTablePageSize,
  (page, sort, text, size) => ({
    page,
    sort,
    text,
    size,
  })
);

export const getCustomersIsFetching = createSelector(getState, customers => customers.isFetching);
export const getCustomersIsExporting = createSelector(getState, customers => customers.isExporting);
export const getCustomersApiError = createSelector(getState, customers => customers.apiError);

const getAllCustomersSelect = createSelector(getState, customers => customers.data.select);
const getCustomersSelectItems = createSelector(getAllCustomersSelect, data => data.items || {});
export const getCustomersSelectLinks = createSelector(getAllCustomersSelect, data => data.links || {});

export const getCustomersCurrentSearch = createSelector(getState, customers => customers.currentSearch);

export const getCustomersSelect = createSelector(getCustomersSelectItems, selectItems => selectItems);

const getCustomerCreationModal = createSelector(getState, customer => customer.modal.creation);
export const isCreationModalVisible = createSelector(getCustomerCreationModal, modal => modal.visible);
export const isCreateCustomerLoading = createSelector(getCustomerCreationModal, modal => modal.loading);

export const getCustomer = createSelector(
  getAll,
  (_, customerId) => customerId,
  (customers, customerId) => customers[customerId] || {}
);

export const getCustomerById = createSelector(
  getAll,
  (_, customerId) => customerId,
  (customers, customerId) => customerId && customers[customerId]
);

export const isCustomerPhoneNumberDisable = createSelector(
  getCustomer,
  customer => Boolean(customer?.phoneNumber?.local)
);

const getDetailsState = createSelector(getState, state => state.ui.details);

const getCustomerHistory = createSelector(getDetailsState, details => details.history);

export const getHistoryItems = createSelector(getCustomerHistory, data => data.items);

export const getHistoryPage = createSelector(getCustomerHistory, data => data.page);

export const hasNextHistory = createSelector(getCustomerHistory, data => Boolean(data.links?.next));

export const isFetchingHistory = createSelector(getCustomerHistory, data => data.loading);
